import Cookies from 'cookies-js'

const UTM_COOKIE_NAME = '_fictiv_utm'

const extractUtmParams = (searchString: string) => {
    const urlParams = new URLSearchParams(searchString)
    let paramString = ''

    urlParams.forEach((value, key) => {
        if (key.includes('utm_')) {
            paramString += `${key}=${value}&`
        }
    })
    return paramString
}

const setUtmCookie = () => {
    const { search, host } = window.location
    const domain = host.includes('fictiv.com')
        ? '.fictiv.com'
        : '.fictivlabs.com'

    const cookieValue = extractUtmParams(search)

    if (cookieValue !== '') {
        Cookies.set(UTM_COOKIE_NAME, cookieValue, {
            domain: domain,
        })
    }
}

export default setUtmCookie
